/**
 * @auth hangdtt
 * Điều chỉnh cấu hình động cho website
 */

 export const DOMAIN_CONSTANT = [
    {
        tenTinh: 'Tỉnh Cao Bằng',
        maTinh: '04',
        getTokenUrl: 'https://asxh-gw.vnptasxh.vn/sldtbxh/oauth/token',
        url: 'https://asxh-gw.vnptasxh.vn/cbg/sldtbxh/',
        domain: 'caobang.vnptasxh.vn',
        domain_san: 'https://sanvieclamcaobang.vnptasxh.vn/',
        name_summary: 'cbg',
        // domain: 'devasxh.it5'
    },
    {
        tenTinh: 'Tỉnh Tuyên Quang',
        maTinh: '08',
        getTokenUrl: 'https://asxh-gw.vnptasxh.vn/sldtbxh/oauth/token',
        url: 'https://asxh-gw.vnptasxh.vn/tqg/sldtbxh/',
        domain: 'tuyenquang.vnptasxh.vn',
        domain_san: 'https://sanvieclamtuyenquang.vnptasxh.vn/',
        name_summary: 'tqg',
        // domain: 'devasxh.it5'
    },
    {
        tenTinh: 'Tỉnh Lạng Sơn',
        maTinh: '20',
        getTokenUrl: 'https://asxh-gw.vnptasxh.vn/sldtbxh/oauth/token',
        url: 'https://asxh-gw.vnptasxh.vn/lsn/sldtbxh/',
        domain: 'langson.vnptasxh.vn',
        domain_san: 'https://sanvieclamlangson.vnptasxh.vn/',
        name_summary: 'lsn',
        // domain: 'devasxh.it5'
    },
    {
        tenTinh: 'Tỉnh Đồng Nai',
        maTinh: '75',
        getTokenUrl: 'https://asxh-gw.vnptasxh.vn/sldtbxh/oauth/token',
        url: 'https://asxh-gw.vnptasxh.vn/dni/sldtbxh/',
        domain: 'dongnai.vnptasxh.vn',
        domain_san: 'https://sanvieclamdongnai.vnptasxh.vn/',
        name_summary: 'dni',
        // domain: 'devasxh.it5'
    },
    {
        tenTinh: 'Tỉnh Vĩnh Long',
        maTinh: '86',
        getTokenUrl: 'https://asxh-gw.vnptasxh.vn/sldtbxh/oauth/token',
        url: 'https://asxh-gw.vnptasxh.vn/bte/sldtbxh/',
        domain: 'bentre.vnptasxh.vn',
        domain_san: 'https://sanvieclambentre.vnptasxh.vn/',
        name_summary: 'bte',
        // Gop tinh
    },
    {
        tenTinh: 'Thành phố Cần Thơ',
        maTinh: '92',
        getTokenUrl: 'https://asxh-gw.soctrang.gov.vn/sldtbxh/oauth/token',
        url: 'https://asxh-gw.soctrang.gov.vn/stg/sldtbxh/',
        domain: 'asxh.soctrang.gov.vn',
        domain_san: 'https://sanvieclam.soctrang.gov.vn/',
        name_summary: 'stg',
        // gop tinh
    },
    {
        tenTinh: 'Tỉnh Tây Ninh',
        maTinh: '80',
        getTokenUrl: 'https://asxh-gw.vnptasxh.vn/sldtbxh/oauth/token',
        url: 'https://asxh-gw.vnptasxh.vn/lan/sldtbxh/',
        domain: 'longan.vnptasxh.vn',
        domain_san: 'https://sanvieclamlongan.vnptasxh.vn/',
        name_summary: 'lan',
        // gop tinh
    },
    {
        tenTinh: 'Tỉnh Ninh Bình',
        maTinh: '37',
        getTokenUrl: 'https://asxh-gw.vnptasxh.vn/sldtbxh/oauth/token',
        url: 'https://asxh-gw.vnptasxh.vn/ndh/sldtbxh/',
        domain: 'namdinh.vnptasxh.vn',
        domain_san: 'https://sanvieclamnamdinh.vnptasxh.vn/',
        name_summary: 'ndh',
        // gop tinh
    },
    {
        tenTinh: 'Tỉnh Phú Thọ',
        maTinh: '25',
        getTokenUrl: 'https://asxh-gw.vnptasxh.vn/sldtbxh/oauth/token',
        url: 'https://asxh-gw.vnptasxh.vn/hbh/sldtbxh/',
        domain: 'hoabinh.vnptasxh.vn',
        domain_san: 'https://sanvieclamhoabinh.vnptasxh.vn/',
        name_summary: 'hbh',
        // gop tinh
    },
    {
        tenTinh: 'Tỉnh Đồng Tháp',
        maTinh: '82',
        getTokenUrl: 'https://asxh-gw.vnptasxh.vn/sldtbxh/oauth/token',
        url: 'https://asxh-gw.vnptasxh.vn/dtp/sldtbxh/',
        domain: 'dongthap.vnptasxh.vn',
        domain_san: 'https://sanvieclamdongthap.vnptasxh.vn/',
        name_summary: 'dtp',
        // gop tinh
    },
    {
        tenTinh: 'Tỉnh Đồng Tháp',
        maTinh: '82',
        getTokenUrl: 'https://asxh-gw.vnptasxh.vn/sldtbxh/oauth/token',
        url: 'https://asxh-gw.vnptasxh.vn/tgg/sldtbxh/',
        domain: 'tiengiang.vnptasxh.vn',
        domain_san: 'https://sanvieclamtiengiang.vnptasxh.vn/',
        name_summary: 'tgg',
        // gop tinh
    },
    {
        tenTinh: 'Tỉnh Thái Nguyên',
        maTinh: '19',
        getTokenUrl: 'https://asxh-gw.vnptasxh.vn/sldtbxh/oauth/token',
        url: 'https://asxh-gw.vnptasxh.vn/bkn/sldtbxh/',
        domain: 'backan.vnptasxh.vn',
        domain_san: 'https://sanvieclambackan.vnptasxh.vn/',
        name_summary: 'bkn',
        // gop tinh
    },
    {
        tenTinh: 'Tỉnh Cà Mau',
        maTinh: '96',
        getTokenUrl: 'https://bhtncm.camau.gov.vn/sldtbxh/oauth/token',
        url: 'https://bhtncm.camau.gov.vn/sldtbxh/',
        domain: 'bhtn.camau.gov.vn',
        domain_san: 'https://sanvieclam.camau.gov.vn/',
        name_summary: 'cmu',
    },
    {
        tenTinh: 'Thành phố Đà Nẵng',
        maTinh: '49',
        getTokenUrl: 'https://asxh-gw.vnptasxh.vn/sldtbxh/oauth/token',
        url: 'https://asxh-gw.vnptasxh.vn/qnm/sldtbxh/',
        domain: 'quangnam.vnptasxh.vn',
        domain_san: 'https://sanvieclamquangnam.vnptasxh.vn/',
        name_summary: 'qnm',
        // gop tinh
    },
    {
        tenTinh: 'Tỉnh Thái Nguyên',
        maTinh: '19',
        getTokenUrl: 'https://asxh-gw.vnptasxh.vn/sldtbxh/oauth/token',
        url: 'https://asxh-gw.vnptasxh.vn/tnn/sldtbxh/',
        domain: 'thainguyen.vnptasxh.vn',
        domain_san: 'https://sanvieclamthainguyen.vnptasxh.vn/',
        name_summary: 'tnn',
        // gop tinh
    },
    {
        tenTinh: 'Tỉnh Khánh Hòa',
        maTinh: '56',
        getTokenUrl: 'https://asxh-gw.vnptasxh.vn/sldtbxh/oauth/token',
        url: 'https://asxh-gw.vnptasxh.vn/kha/sldtbxh/',
        domain: 'khanhhoa.vnptasxh.vn',
        domain_san: 'https://sanvieclamkhanhhoa.vnptasxh.vn/',
        name_summary: 'kha',
        // domain: 'devasxh.it5'
    },
    {
        tenTinh: 'Tỉnh Bắc Ninh',
        maTinh: '24',
        getTokenUrl: 'https://asxh-gw.vnptasxh.vn/sldtbxh/oauth/token',
        url: 'https://asxh-gw.vnptasxh.vn/bnh/sldtbxh/',
        domain: 'bacninh.vnptasxh.vn',
        domain_san: 'https://sanvieclambacninh.vnptasxh.vn/',
        name_summary: 'bnh',
        // domain: 'devasxh.it5'
    },
    {
        tenTinh: 'Tỉnh An Giang',
        maTinh: '91',
        getTokenUrl: 'https://asxh-gw.vnptasxh.vn/sldtbxh/oauth/token',
        url: 'https://asxh-gw.vnptasxh.vn/agg/sldtbxh/',
        domain: 'angiang.vnptasxh.vn',
        domain_san: 'https://sanvieclamangiang.vnptasxh.vn/',
        name_summary: 'agg',
        // domain: 'devasxh.it5'
    },
    {
        tenTinh: 'Tỉnh Ninh Bình',
        maTinh: '37',
        getTokenUrl: 'https://asxh-gw.vnptasxh.vn/sldtbxh/oauth/token',
        url: 'https://asxh-gw.vnptasxh.vn/hnm/sldtbxh/',
        domain: 'hanam.vnptasxh.vn',
        domain_san: 'https://sanvieclamhanam.vnptasxh.vn/',
        name_summary: 'hnm',
        // domain: 'devasxh.it5'
    },
    {
        tenTinh: 'Thành phố Cần Thơ',
        maTinh: '92',
        getTokenUrl: 'https://asxh-gw.vnptasxh.vn/sldtbxh/oauth/token',
        url: 'https://asxh-gw.vnptasxh.vn/hgi/sldtbxh/',
        domain: 'haugiang.vnptasxh.vn',
        domain_san: 'https://sanvieclamhaugiang.vnptasxh.vn/',
        name_summary: 'hgi',
        // gop tinh
    },
    {
        tenTinh: 'Thành phố Cần Thơ',
        maTinh: '92',
        getTokenUrl: 'http://api-asxh.haugiang.gov.vn/sldtbxh/oauth/token',
        url: 'http://api-asxh.haugiang.gov.vn/hgi/sldtbxh/',
        domain: 'asxh.haugiang.gov.vn',
        domain_san: 'http://sanvieclam-asxh.haugiang.gov.vn/',
        name_summary: 'hgi',
        // gop tinh
    },
    {
        tenTinh: 'Tỉnh Lào Cai',
        maTinh: '15',
        getTokenUrl: 'https://asxh-gw.vnptasxh.vn/sldtbxh/oauth/token',
        url: 'https://asxh-gw.vnptasxh.vn/lci/sldtbxh/',
        domain: 'laocai.vnptasxh.vn',
        domain_san: 'https://sanvieclamlaocai.vnptasxh.vn/',
        name_summary: 'lci',
        // domain: 'devasxh.it5'
    },
    {
        tenTinh: 'Tỉnh Khánh Hòa',
        maTinh: '56',
        getTokenUrl: 'https://asxh-gw.vnptasxh.vn/sldtbxh/oauth/token',
        url: 'https://asxh-gw.vnptasxh.vn/lci/sldtbxh/',
        domain: 'trungcapyteninhthuan.vnptasxh.vn',
        domain_san: 'https://sanvieclamninhthuan.vnptasxh.vn/',
        name_summary: 'ntn',
        // gop tinh
    },
    {
        tenTinh: 'Tỉnh Phú Thọ',
        maTinh: '25',
        getTokenUrl: 'https://asxh-gw.vnptasxh.vn/sldtbxh/oauth/token',
        url: 'https://asxh-gw.vnptasxh.vn/hbh/sldtbxh/',
        domain: 'caodangkythuatcongnghe-hoabinh.vnptasxh.vn',
        domain_san: 'https://sanvieclamhoabinh.vnptasxh.vn/',
        name_summary: 'hbh',
        // gop tinh
    },
    {
        tenTinh: 'Tỉnh Vĩnh Long',
        maTinh: '86',
        getTokenUrl: 'https://apibtxh.vinhlong.gov.vn/sldtbxh/oauth/token',
        url: 'https://apibtxh.vinhlong.gov.vn/vlg/sldtbxh/',
        domain: 'btxh.vinhlong.gov.vn',
        domain_san: 'https://vieclamdemo.vnptasxh.vn/',
        name_summary: 'vlg',
    },
    {
        tenTinh: 'Tỉnh An Giang',
        maTinh: '91',
        getTokenUrl: 'https://asxh-gw.vnptasxh.vn/sldtbxh/oauth/token',
        url: 'https://asxh-gw.vnptasxh.vn/kgg/sldtbxh/',
        domain: 'kiengiang.vnptasxh.vn',
        domain_san: 'https://sanvieclamkiengiang.vnptasxh.vn/',
        name_summary: 'kgg',
        // gop tinh
    },
    {
        tenTinh: 'Tỉnh Gia Lai',
        maTinh: '52',
        getTokenUrl: 'https://asxh-gw.vnptasxh.vn/sldtbxh/oauth/token',
        url: 'https://asxh-gw.vnptasxh.vn/gli/sldtbxh/',
        domain: 'gialai.vnptasxh.vn',
        domain_san: 'https://sanvieclamgialai.vnptasxh.vn/',
        name_summary: 'gli',
        // domain: 'devasxh.it5'
    },
    {
        tenTinh: 'Tỉnh Quảng Trị',
        maTinh: '44',
        getTokenUrl: 'https://asxh-gw.vnptasxh.vn/sldtbxh/oauth/token',
        url: 'https://asxh-gw.vnptasxh.vn/qti/sldtbxh/',
        domain: 'quangtri.vnptasxh.vn',
        domain_san: 'https://sanvieclamquangtri.vnptasxh.vn/',
        name_summary: 'qti',
        // domain: 'devasxh.it5'
    },
    {
        tenTinh: 'Test WAF',
        maTinh: '82',
        getTokenUrl: 'https://testwaf-asxh-gw.vnptasxh.vn/sldtbxh/oauth/token',
        url: 'https://testwaf-asxh-gw.vnptasxh.vn/test/sldtbxh/',
        domain: 'testwaf.vnptasxh.vn',
        domain_san: 'https://vieclamtestwaf.vnptasxh.vn/',
        name_summary: 'test',
        // domain: 'devasxh.it5'
    },
    {
        tenTinh: '',
        maTinh: '',
        getTokenUrl: 'https://devgw.vnptasxh.vn/sldtbxh/oauth/token',
        url: 'https://devgw.vnptasxh.vn/sldtbxh/',
        // getTokenUrl: 'https://k8stgg.vnptasxh.vn/sldtbxh/oauth/token',
        // url: 'https://k8stgg.vnptasxh.vn/sldtbxh/',
        domain: 'devasxh.it5',
        domain_san: 'https://vieclamdev.vnptasxh.vn/',
        name_summary: 'dev',
        sso : 'https://ssodev.vnptasxh.vn/realms/asxh/protocol/openid-connect/token'
    },
    {
        tenTinh: '',
        maTinh: '',
        // getTokenUrl: 'https://demogw.vnptasxh.vn/sldtbxh/oauth/token',
        // url: 'https://demogw.vnptasxh.vn/sldtbxh/',
        getTokenUrl: 'https://asxh-gw.vnptasxh.vn/sldtbxh/oauth/token',
        url: 'https://asxh-gw.vnptasxh.vn/sldtbxh/',
        domain: 'demo.vnptasxh.vn',
        domain_san: 'https://vieclamdemo.vnptasxh.vn/',
        name_summary: 'demo',
        sso: 'https://ssodemo.vnptasxh.vn/realms/asxh/protocol/openid-connect/token'
    },
    {
        tenTinh: '',
        maTinh: '',
        getTokenUrl: 'https://devgw.vnptasxh.vn/sldtbxh/oauth/token',
        url: 'https://devgw.vnptasxh.vn/sldtbxh/',
        domain: 'dev.vnptasxh.vn',
        domain_san: 'https://vieclamdev.vnptasxh.vn/',
        name_summary: 'dev',
    },
    {
      tenTinh: '',
      maTinh: '',
      getTokenUrl: 'https://demo-api.vnptasxh.vn/sldtbxh/oauth/token',
      url: 'https://demo-api.vnptasxh.vn/sldtbxh/',
      domain: 'demo-portal.vnptasxh.vn',
      domain_san: 'https://demo-vieclam.vnptasxh.vn/',
      name_summary: 'demo',
    },
    {
        tenTinh: '',
        maTinh: '',
        // getTokenUrl: 'https://demogw.vnptasxh.vn/sldtbxh/oauth/token',
        // url: 'https://demogw.vnptasxh.vn/sldtbxh/',
        getTokenUrl: 'http://10.82.14.212:31000/sldtbxh/oauth/token',
        url: 'http://10.82.14.212:31000/sldtbxh/',
        domain: '10.82.14.212',
        domain_san: 'https://vieclamdemo.vnptasxh.vn/',
        name_summary: 'demo',
    },
    {
        tenTinh: '',
        maTinh: '',
        getTokenUrl: 'https://demo-api.vnptasxh.vn/sldtbxh/oauth/token',
        url: 'https://demo-api.vnptasxh.vn/sldtbxh/',
        domain: 'demo-portal.vnptasxh.vn',
        domain_san: 'https://demo-vieclam.vnptasxh.vn/',
        name_summary: 'demo',
    },
    {
        tenTinh: 'Tỉnh Cà Mau',
        maTinh: '96',
        getTokenUrl: 'https://bhtncm.camau.gov.vn/sldtbxh/oauth/token',
        url: 'https://bhtncm.camau.gov.vn/sldtbxh/',
        domain: 'qlld.camau.gov.vn',
        domain_san: 'https://sanvieclam.camau.gov.vn/',
        name_summary: 'cmu',
    },
];

export const LIST_TINH_THANH = ['04', '08', '20', '75', '86', '94', '80', '36', '17', '87'];

export const MA_TINH_HBH = '17';
export const MA_TINH_LSN = '20';
export const MA_TINH_NDH = '36';
export const MA_TINH_LAN = '80';
export const MA_TINH_DNI = '75';
export const MA_TINH_TGG = '82';
export const MA_TINH_BTE = '86';
export const MA_TINH_STG = '94';
export const MA_TINH_DTP = '87';
export const MA_TINH_QNM = '49';
